import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { Profile } from '../../../shared/types';
import axiosService from '../services/axios.service';

// This would be your actual API service function
const getMyProfile = async (crewSlug: string): Promise<Profile | null> => {
    try {
        const { data: response } = await axiosService.get(`/c/${crewSlug}/profiles/me`);
        return response.data as Profile;
    } catch (error: any) {
        if (error.response?.status === 404 || error.response?.status === 403) return null;
        throw new Error('Failed to fetch crew member profile');
    }
};

export const useCurrentCrewMember = (crewSlug?: string) => {
    const { user } = useAuth();

    return useQuery<Profile | null>({
        queryKey: ['crewMember', crewSlug, user?.guid],
        queryFn: () => getMyProfile(crewSlug!),
        enabled: !!(crewSlug && user?.guid),
        staleTime: 5 * 60 * 1000 // 5 minutes

    });
};
